import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Login from '../session/Login';
import { sessionService, alertService } from '../_services';
import useToken from '../session/Token';
import { cookieHelper } from '../_helpers/cookie-helper';

function Logout({ match }) {
    const history = useHistory();
    const { path } = match;
    const { token, setToken } = useToken();

    useEffect(() => {
        sessionService
          .delete()
          .then(() => {
            cookieHelper.deleteAllCookies();
            history.push("/login");
            setToken('');
        }).catch((error) => {
            // With error still push to login
            cookieHelper.deleteAllCookies();
            history.push("/login");
            alertService.error;
            setToken('');
        })
        alertService.clear();
        alertService.info('Logged Out.');
    }, []);

    function deleteSession(){
        return false
    }

    return  <Login setToken={deleteSession} />
}

export { Logout };
